export const /** @type {?} */ JOB_TYPE = {
  entrepreneur: 'Entrepreneur',
  enemployed: 'Unemployed',
  student: 'Student',
  other: 'Other',
  retiredPublicServant: 'RetiredPublicServant',
  retired: 'Retired',
};

export const /** @type {?} */ POST_LOAN_ENVIRONMENT =
  'U2FsdGVkX1/Ng72grsfJEZ75ou2hODFkMlwsBPxPNVw=';
export const /** @type {?} */ POST_LOAN_VERSION = '3';

export const /** @type {?} */ ENTREPRENEUR_LOAN_TYPE = 'business';
